import { render, staticRenderFns } from "./TestingCenterTimeCard.vue?vue&type=template&id=b4a876a2&"
import script from "./TestingCenterTimeCard.vue?vue&type=script&lang=ts&"
export * from "./TestingCenterTimeCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports